import Logout from './Logout.container';

export default Logout;
